import { Oval } from 'react-loader-spinner'
/**
 * @description 로딩바 컴포넌트
 * @author 이종술
 * @since 2023-02-05
 * 업무 : 컴포넌트 > 로딩바
 */

export default function LoadingSpanner({ isLoading }) {
  return (
    <>
      {isLoading && (
        <>
          <div className={`loader-deemed show`}>
            {/* <div className="deemed"></div> */}
            {/* <div className="loader"></div> */}
            <div className="loading-wrap">
              <div className="loading">
                <i className="dot"></i>
                <i className="dot"></i>
                <i className="dot"></i>
              </div>
            </div>
          </div>
          {/* <div
            style={{
              display: 'block',
              // display: 'block',
              position: 'fixed',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              background: '#000',
              zIndex: 9999,
              opacity: 0,
              filter: 'alpha(opacity=0)',
            }}
          ></div>
          <Oval
            height="60"
            width="60"
            color="#008f69"
            ariaLabel="oval-loading"
            wrapperStyle={{
              display: 'block',
              // display: 'block',
              position: 'fixed',
              top: '50%',
              left: '50%',
              zIndex: '10000',
              margin: '-30px -30px 30px -30px',
            }}
            wrapperClass=""
            secondaryColor="#4fa94d"
            strokeWidth={4}
          /> */}
        </>
      )}
    </>
  )
}
